export enum LocationEnum {
  CLUB = "CLUB",
  DES_PRES = "DES_PRES",
  NYC = "NYC",
  IBIZA = "IBIZA",
  HORS_LES_MURS = "HORS_LES_MURS",
}
